import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CustomerType, CustomerTypeSaveEntity } from 'app/layout/customer/customer-type/customer-type.model';
import { BaseComponent } from '../../base.component';
import { Severities } from '../../shared.model';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html'
})
export class AddCustomerComponent extends BaseComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() done = new EventEmitter();
  constructor(protected translateService: TranslateService, protected sharedService: SharedService,
    private _fb: FormBuilder) {
    super(sharedService, translateService)
  }
  frmCustomertype: FormGroup;
  isSaveAttempt: boolean = false;
  isNetwork: boolean = false;
  ngOnInit() {
    this.frmInialize();
    this.getCustomerTypes();
  }
  frmInialize() {
    this.frmCustomertype = this._fb.group({
      CustomerType: ['', Validators.required],
      CustomerTypeNo: ['', Validators.required],
      Description: ['']
    });
  }

  getCustomerTypes() {
    this.sharedService.getCustomerTypes(super.globalInfo().CompanyId).subscribe(res => {
      this.isNetwork = res.find(s => s.IsNetwork == 0) ? false : true;
    });
  }
  loader: boolean = false;
  addCustomerType() {
    this.isSaveAttempt = true;
    if (this.frmCustomertype.valid) {
      this.loader = true;
      let insCustomerType = this.frmCustomertype.value;
      insCustomerType.CustomerTypeId = 0;
      insCustomerType.CreatedBy = super.globalInfo().LoginId;;
      insCustomerType.CompanyId = super.globalInfo().CompanyId;
      insCustomerType.IsNetwork = (this.isNetwork ? 1 : 0);
      insCustomerType.IsSystemDefined = 0;
      insCustomerType.DispatchBoardAccess = 0;
      insCustomerType.LiveMapAccess = 0;
      insCustomerType.DashboardAccess = 0;
      insCustomerType.CustomerPortalAccess = 0;
      insCustomerType.HolidayTemplateId = 0;
      insCustomerType.PriorityId = 0;
      insCustomerType.LogoPath = '';
      insCustomerType.IsActive = 1;
      var entity = new CustomerTypeSaveEntity();
      entity.CustomerTypeEntity = insCustomerType;
      this.sharedService.addCustomerType(entity).subscribe(s => {
        this.loader = false;
        if (s.Message.MessageCode == "1001" || s.Message.MessageCode == "1002") {
          s.Message.MessageCode = "1004";
          this.sharedService.notification.emit({
            severity: Severities[s.Message.Severity],
            summary: this.translate.instant("SUCCESS"),
            detail: this.translate.instant('CUSTYPE') + " " + this.translate.instant(s.Message.MessageCode)
          });
          this.done.emit(s.Data);
        }
        else 
          this.sharedService.notification.emit({ severity: Severities[s.Message.Severity], summary: this.translate.instant(s.Message.MessageCode) });        
      }, e => { this.loader = false; });
    }
  }
  closePopup(event: boolean = false) {
    this.close.emit(false);
  }
}
